import { render, staticRenderFns } from "./calendarattendant.vue?vue&type=template&id=9fdb43a0&"
import script from "./calendarattendant.js?vue&type=script&lang=js&"
export * from "./calendarattendant.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fdb43a0')) {
      api.createRecord('9fdb43a0', component.options)
    } else {
      api.reload('9fdb43a0', component.options)
    }
    module.hot.accept("./calendarattendant.vue?vue&type=template&id=9fdb43a0&", function () {
      api.rerender('9fdb43a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/calendar/calendarattendant.vue"
export default component.exports